import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import ButtonCount from "../../components/ButtonCount/ButtonCount";
import useStyles from "./styles";
import Badge from "../../components/Badge/Badge";
import { Grid } from "@mui/material";
import Table from "../../components/Table/Table";
import { AgreedScore, StaffScore, ManagerScore, Employees, GoalCategory } from "../../utils/DropDown";
import { TableSearch } from "../../components/Table/TableActions";
import Modal from "../../components/Modal";
import { Icon } from "@iconify/react";

// --| Dummy data
import PervEval from "../../dummy_data/PervEval.json";
// import { Link } from "react-router-dom";
import InputGroup from "../../components/FormComponent/InputGroup";
import SelectGroup from "../../components/FormComponent/SelectGroup";

const PerfEval = () => {
  const classes = useStyles();
  // const [modalisopen, setModalIsOpen] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [addInfoModal, setAddInfoModal] = useState(false);
  const [editInfoModal, setEditInfoModal] = useState(false);
  const [addscoreModal, setAddScoreModal] = useState(false);

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const handleAddscoreModal = (row) => {
    setAddScoreModal(!addscoreModal);
    setCurrentRow(row);
  };

  const handleEditInfoModal = (row) => {
    setEditInfoModal(!editInfoModal);
    setCurrentRow(row);
  };

  const handleCloseEditInfo = () => {
    setEditInfoModal(false);
  };

  const handleAddInfoModal = () => {
    setAddInfoModal(!addInfoModal);
  };

  const handleCloseAddInfoModal = () => {
    setAddInfoModal(false);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  // On Page Load, set search result data to be the initial data
  useEffect(() => {
    // The data will be from the teacher get api endpint
    setSearchResult(PervEval);
  }, []);
  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name
    },
    {
      name: "Goal",
      selector: (row) => row?.goal
    },
    {
      name: "Role",
      selector: (row) => row?.role
    },
    {
      name: "Reporting To",
      selector: (row) => row?.reportingto
    },
    {
      name: "Weight",
      selector: (row) => row?.weight
    },
    {
      name: "Point Average",
      selector: (row) => row?.pointAve
    },
    {
      name: "Status",
      center: true,
      cell: (row) => (<Badge status={row?.status} />)
    },

    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => {
              handleAddscoreModal(row);
            }}
            className="table-action-icon"
          >
            <Icon icon="ic:outline-folder" />
          </button>
          <button className="table-action-icon" onClick={() => {
            handleEditInfoModal(row);
          }}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Teacher table using name, email and class
  const handleSearchTeacher = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = PervEval?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.email
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.class
                      ?.toLowerCase()
                      .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Performance Evaluation"
            subtitle="You can create Organisation goals and track goals of your employees"
            button={
              <div className="flex gap-10">
                <Button
                  variant="primary"
                  buttonSize="small"
                  color="btndefault"
                  onClick={handleAddInfoModal}
                  buttonName="Create Goals"
                />
              </div>
            }
          />
          <div className={classes.pageContent}>
            <div className={classes.contentpadding}>
              <ButtonCount title="Goal Category Count" count={0} />
            </div>
            <Table
              data={searchResult}
              columns={columns}
              subHeader={true}
              subHeaderComponent={
                <TableSearch
                  placeholder="Search here..."
                  searchTableFunc={handleSearchTeacher}
                />
              }
            />
          </div>
          {/* Add Modal */}
          <Modal
            title="Goal Planning"
            subtitle={
              <div>Set Goals and Assign to your teachers to track progress.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Goal"
                      margin="normal"
                      placeHolder="Enter the goal"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Category" children={
                      <select>
                        <option value="">---Select ---</option>
                        {GoalCategory?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Assign to" children={
                      <select>
                        <option value="">---Select ---</option>
                        {Employees?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Reporting to" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {Employees?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Due Date"
                      margin="normal"
                      inputType="date"
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Save" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={addInfoModal}
            closeModal={handleCloseAddInfoModal}
          />
          {/* SCORE MODAL */}
          <Modal
            title="Review and Performance Evaluation."
            subtitle={
              <div>Score and employee based off the progress of the goal.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Goal"
                      margin="normal"
                      placeHolder="Enter the goal"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Category" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {GoalCategory?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <div className={classes.paddingleftmodal}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup label="Manager's Score" children={
                        <select>
                          <option value="">--- Select ---</option>
                          {ManagerScore?.map((label) => {
                            return (
                              <option key={label.key}>{label?.text}</option>
                            );
                          })}
                        </select>
                      }
                      />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup label="Staff Score" children={
                        <select>
                          <option value="">--- Select ---</option>
                          {StaffScore?.map((label) => {
                            return (
                              <option key={label.key}>{label?.text}</option>
                            );
                          })}
                        </select>
                      }
                      />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <SelectGroup label="Agreed Score" children={
                        <select>
                          <option value="">--- Select ---</option>
                          {AgreedScore?.map((label) => {
                            return (
                              <option key={label.key}>{label?.text}</option>
                            );
                          })}
                        </select>
                      }
                      />
                    </Grid>
                  </div>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Continue" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={addscoreModal}
            closeModal={handleAddscoreModal}
          />
          {/* Edit Modal */}
          <Modal
            title={`Goal Planning ${currentRow?.title}`}
            subtitle={
              <div>Set Goals and Assign to your teachers to track progress. {currentRow?.title}
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Goal"
                      margin="normal"
                      placeHolder="Enter the goal"
                      inputType="text"
                      defaultValue={currentRow?.title}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Category" children={
                      <select defaultValue={currentRow?.label}>
                        <option value="">--- Select ---</option>
                        {GoalCategory?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Assign to" children={
                      <select defaultValue={currentRow?.access}>
                        <option value="">--- Select ---</option>
                        {Employees?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Reporting to" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {Employees?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Due Date"
                      margin="normal"
                      inputType="date"
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Continue" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={editInfoModal}
            closeModal={handleCloseEditInfo}
          />
          {/* Delete Modal */}
          <Modal
            title="Delete Performance Evaluation"
            subtitle={
              <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.title}</span>. If deleted, employee will no longer have access to this information.`
              </div>}
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                <Button variant="danger" buttonName="Delete Evaluation" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
        </>
      }
    />
  );
};

export default PerfEval;
